import * as ngCore from '@angular/core'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Coordinates visual navigation transitions for app content.
 *
 * Angular Router knows when the URL changes, but this app renders portal pages
 * through a custom `@switch(pageId)` pseudo-outlet. This feature bridges that
 * gap: navigation starts here or from router-store events, and app content
 * explicitly reports when the selected page has rendered.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    const routerFeature = ngCore.inject(router.Router)

    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Navigation',
      selectors: () => new Selectors(this),
    })

    this.registerEffects(
      effects.executeNavigate(routerFeature),
      effects.startOnRouterRequest(routerFeature),
      effects.finishAfterPageRendered(),
      effects.finishOnRouterEnd(routerFeature),
    )
  }
}
